import React, { useEffect } from "react";
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import AuthorizedRoutes from "./AutherizedRoute";
import UnAuthorizedRoutes from "./UnAutherizedAoutes";
import MaintenanceRoute from "./MaintenanceRoute";
import AdminRoute from "./AdminRoute";


const AppRoutes:React.FC = () => {
    // useEffect(()=>{
    //     const logRoutes = (routeList:any) => {
    //         routeList.forEach((route:any) => {
    //           console.log(`Route path: ${route.path}, Component: ${route.element.type.name}`);
    //           if (route.children) {
    //             logRoutes(route.children); // Recursively log child routes
    //           }
    //         });
    //       };
    //       logRoutes([UnAuthorizedRoutes, UnAuthorizedRoutes, MaintenanceRoute]);
    // },[])
    const allRoutes = useRoutes([UnAuthorizedRoutes, AuthorizedRoutes, MaintenanceRoute, AdminRoute])
    return allRoutes
}

export default AppRoutes
